export const EMAIL_VERIFIED = "EMAIL_VERIFIED";
export const EMAIL_NOT_VERIFIED = "EMAIL_NOT_VERIFIED";


// WEBPACK FOOTER //
// ./src/components/dashboard/clients/enums/memberActivationStatusTypes.js